if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.sym-slides_three').slick({
        accessibility: false
    });

    


    //dropdown for mobile
	document.querySelectorAll('.privary-navigation > ul > li > a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('.privary-navigation > ul > li').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('js-submenu-show');
				});
				//remove this comment if you want show subnav for mobile
				e.preventDefault();
				link.parentNode.classList.toggle('js-submenu-show');
			}
		});
	});
	//add class for icon dropdown 
	document.querySelectorAll('.privary-navigation > ul > li > .submenu').forEach(link => {
		let menu = link.parentNode.firstElementChild;
		menu.classList.add('ico-dropdown');
	})


    
    // $('.sym-slides.slider').slick("refresh");

})();